import { useState } from "react";
import { assetUrl, cn } from "@/lib/utils";

function initials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");
}

export function TeamFlag({ name, flag, className }: { name: string; flag?: string | null; className?: string }) {
  const [broken, setBroken] = useState(false);
  const src = assetUrl(flag);

  if (!src || broken) {
    return (
      <span
        className={cn(
          "grid size-6 shrink-0 place-items-center rounded-full bg-muted text-[0.6rem] font-semibold text-muted-foreground",
          className,
        )}
        aria-hidden
      >
        {initials(name)}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt=""
      aria-hidden
      onError={() => setBroken(true)}
      className={cn("size-6 shrink-0 rounded-full object-cover", className)}
    />
  );
}
